<template>
  <div class="zp-page">
    <div v-if="loading" class="zp-loading">Yuklanmoqda...</div>

    <div v-else-if="!order" class="zp-loading">Buyurtma topilmadi</div>

    <div v-else class="zp-wrapper">

      <!-- Tugmalar (chop qilishda yashiriladi) -->
      <div class="zp-actions no-print">
        <button class="zp-btn zp-btn-print" @click="printReceipt">
          <md-icon>print</md-icon> Chop etish
        </button>
        <button class="zp-btn zp-btn-close" @click="closeWindow">
          <md-icon>close</md-icon> Yopish
        </button>
      </div>

      <!-- CHEK (POS savdo cheki ko'rinishi) -->
      <div class="receipt" id="zakaz-receipt">

        <!-- Logo + Firma header -->
        <div class="receipt-header">
          <img v-if="logoUrl" :src="logoUrl" class="receipt-logo" alt="logo" />
          <div class="firm-name">{{ firmName || 'PROFCAR' }}</div>
          <div v-if="phone" class="firm-phone">Tel: {{ phone }}</div>
          <div class="doc-type">BUYURTMA CHEKI</div>
          <div class="receipt-date">{{ formatDate(order.created_at) }}</div>
        </div>

        <div class="receipt-divider"></div>

        <!-- META -->
        <div class="receipt-info">
          <div class="info-row">
            <span class="info-label">№ buyurtma:</span>
            <span class="info-value">{{ order.id }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Mijoz:</span>
            <span class="info-value">{{ clientName }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Tel:</span>
            <span class="info-value">{{ clientPhone }}</span>
          </div>
          <div v-if="order.address" class="info-row">
            <span class="info-label">Manzil:</span>
            <span class="info-value">{{ order.address }}</span>
          </div>
        </div>

        <!-- IZOH -->
        <template v-if="order.comment">
          <div class="receipt-divider"></div>
          <div class="receipt-comment">{{ order.comment }}</div>
        </template>

        <!-- XIZMATLAR (Service) — har xizmat + materiallari -->
        <template v-if="serviceGroups.length > 0">
          <div class="receipt-divider"></div>
          <div class="section-title">XIZMATLAR</div>
          <div class="receipt-divider-solid"></div>
          <div v-for="(s, i) in serviceGroups" :key="'s' + i" class="service-block">
            <div class="item-row">
              <span class="ir-name">{{ i + 1 }}. {{ s.name }}</span>
              <span v-if="s.count > 1" class="ir-qty">x{{ s.count }}</span>
            </div>
            <div v-for="(m, mi) in s.materials" :key="'m' + mi" class="material-row">
              <span class="mr-name">&#8627; {{ m.name }}</span>
              <span class="mr-qty">{{ m.qty }}</span>
            </div>
          </div>
        </template>

        <!-- MAHSULOTLAR (Product) — faqat mustaqil mahsulotlar (xizmatsiz) -->
        <template v-if="standaloneProducts.length > 0">
          <div class="receipt-divider"></div>
          <div class="section-title">MAHSULOTLAR</div>
          <div class="receipt-divider-solid"></div>
          <template v-for="(p, i) in standaloneProducts">
            <div :key="'p' + i" class="item-row">
              <span class="ir-name">{{ i + 1 }}. {{ p.name }}</span>
              <span class="ir-qty">{{ p.count }}</span>
            </div>
            <div v-if="i < standaloneProducts.length - 1" :key="'separator-' + i" class="item-separator"></div>
          </template>
        </template>

        <div v-if="serviceGroups.length === 0 && standaloneProducts.length === 0" class="receipt-empty">
          Buyurtmada xizmat ham, mahsulot ham yo'q.
        </div>

        <div class="receipt-divider"></div>

        <!-- Footer -->
        <div class="receipt-footer">
          <div v-if="checkWord" class="check-word">{{ checkWord }}</div>
          <div class="thank-you">Rahmat!</div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZakazPrint',
  data() {
    return {
      order: null,
      loading: true,
      firmName: '',
      phone: '',
      logoUrl: '',
      checkWord: '',
    };
  },
  computed: {
    clientName() {
      if (this.order && this.order.kontragent && this.order.kontragent.name) return this.order.kontragent.name;
      return '—';
    },
    clientPhone() {
      if (this.order && this.order.kontragent && this.order.kontragent.phone_number) return this.order.kontragent.phone_number;
      if (this.order && this.order.phone_number) return this.order.phone_number;
      return '—';
    },
    // Xizmatga tegishli mahsulotlarning product_id to'plami (mustaqil mahsulotlardan ajratish uchun)
    serviceMaterialIds() {
      const ids = new Set();
      const services = (this.order && this.order.services) || [];
      for (const s of services) {
        for (const it of (s.items || [])) {
          if (it.product_id != null) ids.add(it.product_id);
        }
      }
      return ids;
    },
    // Xizmatlarni guruhlash (package_id bo'yicha) + materiallari (extra_name, narxsiz)
    serviceGroups() {
      const services = (this.order && this.order.services) || [];
      const map = new Map();
      for (const s of services) {
        const key = s.package_id != null ? 'p' + s.package_id : 'n' + (s.name || '');
        if (!map.has(key)) {
          map.set(key, { name: s.name || '—', count: 0, items: s.items || [] });
        }
        map.get(key).count += 1;
      }
      return Array.from(map.values()).map(g => ({
        name: g.name,
        count: g.count,
        materials: (g.items || []).map(it => ({
          name: this.itemName(it),
          qty: Number(it.quantity || 1) * g.count,
        })),
      }));
    },
    // Faqat mustaqil mahsulotlar (xizmatga tegishli bo'lmaganlari), extra_name bilan
    standaloneProducts() {
      const products = (this.order && this.order.products) || [];
      return products
        .filter(p => !this.serviceMaterialIds.has(p.product_id))
        .map(p => ({ name: this.productName(p), count: Number(p.count || 0) }));
    },
  },
  mounted() {
    this.fetchOrder();
    window.addEventListener('afterprint', this.notifyPrintDone);
  },
  beforeDestroy() {
    window.removeEventListener('afterprint', this.notifyPrintDone);
  },
  methods: {
    async fetchOrder() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        const res = await axios.get('/api/v1/bron/print/' + id);
        this.order = res.data || null;
        if (this.order) await this.fetchSkladHeader();
      } catch (e) {
        console.error('Buyurtmani yuklashda xato:', e);
        this.order = null;
      } finally {
        this.loading = false;
        if (this.$route.query.autoprint === '1' && this.order) {
          this.$nextTick(() => {
            setTimeout(() => {
              window.focus();
              window.print();
            }, 250);
          });
        }
      }
    },
    // Firma nomi / telefon / logo / chek izohini sklad sozlamalaridan olish (POS bilan bir xil)
    async fetchSkladHeader() {
      const sklad_id = (this.order && this.order.sklad_id) || localStorage.getItem('sklad_id');
      if (!sklad_id) return;
      try {
        const [skladRes, settingsRes] = await Promise.all([
          axios.get(`/api/v1/sklads/id/${sklad_id}`),
          axios.post('/api/v1/sklad-settings', { sklad_id, key: 'a4_printer' }),
        ]);
        const sklad = (skladRes.data && (skladRes.data.data || skladRes.data)) || {};
        this.phone = sklad.phone_number || '';
        this.checkWord = sklad.check_word || '';
        const printerData = settingsRes.data && settingsRes.data.data;
        if (printerData) {
          const parsed = JSON.parse(printerData);
          this.firmName = (parsed && parsed.sender && parsed.sender.firm_name) || sklad.name || '';
          if (parsed && parsed.file_name) {
            this.logoUrl = axios.defaults.baseURL + 'api/v1/uploads/' + parsed.file_name;
          }
        } else {
          this.firmName = sklad.name || '';
        }
      } catch (e) {
        // sozlama topilmasa, sklad nomisiz davom etamiz
      }
    },
    productName(p) {
      if (p && p.product) return p.product.extra_name || p.product.name || '—';
      return '—';
    },
    itemName(it) {
      if (it && it.product) return it.product.extra_name || it.product.name || '—';
      return '—';
    },
    formatDate(ts) {
      if (!ts) return '-';
      const d = new Date(ts * 1000);
      return d.toLocaleDateString('ru-RU') + ' ' + d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
    },
    closeWindow() {
      window.close();
    },
    notifyPrintDone() {
      if (window.parent && window.parent !== window) {
        window.parent.postMessage({ type: 'zakaz-print-done' }, window.location.origin);
      }
    },
    // Savdo POS chek kabi — joriy sahifada toza 80mm chek chop etish
    printReceipt() {
      const el = document.getElementById('zakaz-receipt');
      if (!el) return;
      const printWindow = this.$route.query.popup === '1'
        ? window.open('', '_blank', 'width=320,height=600')
        : null;
      if (!printWindow) {
        window.print();
        return;
      }
      printWindow.document.write(`<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<title>Buyurtma cheki</title>
<style>
  @page { size: 80mm auto; margin: 0; }
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body {
    width: 80mm;
    font-family: 'Arial', 'Helvetica', sans-serif;
    font-size: 12px;
    font-weight: 700;
    color: #000;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    padding: 3mm;
  }
  .receipt-logo { display: block; max-width: 60mm; max-height: 22mm; margin: 0 auto 2mm; object-fit: contain; }
  .receipt-header { text-align: center; margin-bottom: 2mm; }
  .firm-name { font-size: 16px; font-weight: 900; letter-spacing: 0.5px; text-transform: uppercase; }
  .firm-phone { font-size: 11px; margin-top: 1mm; }
  .doc-type { font-size: 11px; font-weight: 700; margin-top: 1mm; }
  .receipt-date { font-size: 11px; margin-top: 1mm; }
  .receipt-divider { border-top: 1px dashed #000; margin: 2mm 0; }
  .receipt-divider-solid { border-top: 1px solid #000; margin: 1mm 0; }
  .receipt-info { margin: 1mm 0; }
  .info-row { display: flex; justify-content: space-between; font-size: 12px; line-height: 1.5; gap: 6px; }
  .info-label { color: #000; }
  .info-value { font-weight: 700; text-align: right; max-width: 60%; word-break: break-word; }
  .receipt-comment { font-size: 11px; font-style: italic; text-align: center; white-space: pre-wrap; }
  .section-title { text-align: center; font-weight: 800; letter-spacing: 1px; font-size: 12px; }
  .service-block { margin-bottom: 1mm; }
  .item-row { display: flex; justify-content: space-between; gap: 4px; align-items: baseline; font-size: 12px; line-height: 1.5; padding: 1.5mm 0; page-break-inside: avoid; break-inside: avoid; }
  .item-separator { display: block; width: 100%; height: 3px; min-height: 3px; background: #000 !important; }
  .ir-name { font-weight: 700; word-break: break-word; overflow-wrap: anywhere; }
  .ir-qty { font-weight: 700; white-space: nowrap; }
  .material-row { display: flex; justify-content: space-between; gap: 4px; padding: 1mm 0 1mm 3mm; font-size: 11px; line-height: 1.4; border-bottom: 1px dashed #000; }
  .mr-name { word-break: break-word; overflow-wrap: anywhere; }
  .mr-qty { white-space: nowrap; }
  .receipt-empty { text-align: center; font-style: italic; padding: 3mm 0; }
  .receipt-footer { text-align: center; margin-top: 2mm; padding-bottom: 3mm; }
  .check-word { font-weight: 800; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px; }
  .thank-you { font-weight: 800; font-size: 13px; margin-top: 1mm; }
</style>
</head>
<body>${el.innerHTML}</body>
</html>`);
      printWindow.document.close();
      printWindow.focus();
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 400);
    },
  }
};
</script>

<style scoped>
.zp-page {
  background: #e2e8f0;
  min-height: 100vh;
  padding: 16px;
  display: flex;
  justify-content: center;
  font-family: 'Arial', 'Helvetica', sans-serif;
}

.zp-loading {
  text-align: center;
  padding: 40px 10px;
  color: #64748b;
  font-style: italic;
}

.zp-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

/* === Action buttons === */
.zp-actions { display: flex; gap: 10px; }

.zp-btn {
  height: 40px;
  padding: 0 20px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-family: inherit;
}
.zp-btn-print { background: #10b981; color: white; border: none; }
.zp-btn-print:hover { background: #0ea271; }
.zp-btn-close { background: white; color: #64748b; border: 1px solid #e2e8f0; }
.zp-btn-close:hover { background: #f1f5f9; }

/* === Chek (80mm simulyatsiya) === */
.receipt {
  background: white;
  width: 302px;
  padding: 12px;
  font-family: 'Arial', 'Helvetica', sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: #000;
  border-radius: 2px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18);
}

.receipt-logo { display: block; max-width: 220px; max-height: 80px; margin: 0 auto 6px; object-fit: contain; }
.receipt-header { text-align: center; margin-bottom: 6px; }
.firm-name { font-size: 16px; font-weight: 900; letter-spacing: 0.5px; text-transform: uppercase; }
.firm-phone { font-size: 11px; margin-top: 2px; }
.doc-type { font-size: 11px; font-weight: 700; margin-top: 2px; }
.receipt-date { font-size: 11px; margin-top: 2px; }

.receipt-divider { border-top: 1px dashed #000; margin: 6px 0; }
.receipt-divider-solid { border-top: 1px solid #000; margin: 3px 0; }

.receipt-info { margin: 4px 0; }
.info-row { display: flex; justify-content: space-between; font-size: 12px; line-height: 1.5; gap: 6px; }
.info-label { color: #000; }
.info-value { font-weight: 700; text-align: right; max-width: 60%; word-break: break-word; }
.receipt-comment { font-size: 11px; font-style: italic; text-align: center; white-space: pre-wrap; }

.section-title { text-align: center; font-weight: 800; letter-spacing: 1px; font-size: 12px; }
.service-block { margin-bottom: 4px; }
.item-row { display: flex; justify-content: space-between; gap: 4px; align-items: baseline; font-size: 12px; line-height: 1.5; padding: 5px 0; page-break-inside: avoid; break-inside: avoid; }
.item-separator { display: block; width: 100%; height: 3px; min-height: 3px; background: #000 !important; }
.ir-name { font-weight: 700; word-break: break-word; overflow-wrap: anywhere; }
.ir-qty { font-weight: 700; white-space: nowrap; }
.material-row { display: flex; justify-content: space-between; gap: 4px; padding: 4px 0 4px 12px; font-size: 11px; line-height: 1.4; border-bottom: 1px dashed #000; }
.mr-name { word-break: break-word; overflow-wrap: anywhere; }
.mr-qty { white-space: nowrap; }
.receipt-empty { text-align: center; font-style: italic; padding: 12px 0; }

.receipt-footer { text-align: center; margin-top: 6px; }
.check-word { font-weight: 800; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px; }
.thank-you { font-weight: 800; font-size: 13px; margin-top: 3px; }

@media print {
  @page { size: 80mm auto; margin: 0; }
  .no-print { display: none !important; }
  .zp-page { background: none; padding: 0; display: block; min-height: 0; }
  .zp-wrapper { gap: 0; }
  .receipt { width: 80mm; box-shadow: none; padding: 3mm; border-radius: 0; }
}
</style>
